
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const CarMultimediaDetailsPage = () => {
  const specifications = [
    { label: 'Screen Size', value: '10.25" - 12.3" Touchscreen' },
    { label: 'Resolution', value: '1920 x 720 HD IPS Display' },
    { label: 'Compatibility', value: 'BMW, Mercedes, Audi, Ford & More' },
    { label: 'Installation', value: 'Plug & Play - Factory Integration' },
    { label: 'Processor', value: 'Qualcomm Snapdragon 665' },
    { label: 'Memory', value: '4GB RAM + 64GB Storage' },
    { label: 'Operating System', value: 'Android 13' },
    { label: 'Warranty', value: '2 Years Manufacturer Warranty' },
  ];

  const features = [
    {
      icon: 'ri-smartphone-line',
      title: 'Wireless CarPlay & Android Auto',
      description:
        'Seamless wireless connection to your iPhone or Android device for navigation, music, and calls',
    },
    {
      icon: 'ri-navigation-line',
      title: 'Built-in GPS Navigation',
      description:
        'Offline maps with real-time traffic updates and voice-guided turn-by-turn directions',
    },
    {
      icon: 'ri-music-line',
      title: 'Premium Audio System',
      description:
        'High-fidelity sound output with equalizer settings and support for all audio formats',
    },
    {
      icon: 'ri-bluetooth-line',
      title: 'Bluetooth 5.0',
      description:
        'Fast and stable wireless connectivity for hands-free calling and audio streaming',
    },
    {
      icon: 'ri-camera-line',
      title: 'Backup Camera Support',
      description:
        'Compatible with rear-view and 360-degree camera systems with parking guidelines',
    },
    {
      icon: 'ri-steering-2-line',
      title: 'Steering Wheel Controls',
      description:
        'Full integration with factory steering wheel buttons for safe operation while driving',
    },
  ];

  const galleryImages = [
    'https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/7888df96dd9476e9f25a4d04add561f9.png',
    'https://public.readdy.ai/ai/img_res/62fb539720d428b3d65704f428b1116a.jpg',
    'https://readdy.ai/api/search-image?query=Car%20multimedia%20screen%20showing%20Android%20Auto%20interface%20with%20Google%20Maps%20Spotify%20WhatsApp%20apps%20modern%20touchscreen%20display%20in%20BMW%20dashboard%20premium%20automotive%20technology%20professional%20product%20photography&width=800&height=600&seq=android001&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Car%20multimedia%20player%20installation%20process%20plug%20and%20play%20connection%20factory%20wiring%20harness%20automotive%20technician%20installing%20touchscreen%20display%20in%20vehicle%20dashboard%20professional%20workshop%20environment&width=800&height=600&seq=install001&orientation=landscape',
  ];

  return (
    <div className="min-h-screen bg-primary-black text-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-16 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-b from-zinc-950 via-zinc-900 to-zinc-950" />
          <div className="absolute top-1/4 left-1/3 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl" />
          <div className="absolute bottom-1/4 right-1/3 w-80 h-80 bg-amber-600/10 rounded-full blur-3xl" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left: Product Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden border-2 border-amber-500/20 shadow-2xl">
                <img
                  src="https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/7888df96dd9476e9f25a4d04add561f9.png"
                  alt="Car Radio Multimedia Player"
                  className="w-full h-auto"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-amber-500 text-black px-6 py-3 rounded-xl font-bold text-lg shadow-xl">
                <i className="ri-verified-badge-line mr-2" />
                CarPlay & Android Auto
              </div>
            </div>

            {/* Right: Product Info */}
            <div>
              <div className="inline-flex items-center gap-2 mb-4 px-4 py-2 bg-amber-500/10 border border-amber-500/30 rounded-full">
                <i className="ri-star-fill text-amber-500" />
                <span className="text-amber-500 text-sm font-semibold">
                  Premium Multimedia System
                </span>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                Car Radio Multimedia Player
              </h1>
              <p className="text-xl text-zinc-400 mb-6">
                Upgrade your vehicle with a premium touchscreen multimedia system featuring wireless
                Apple CarPlay, Android Auto, GPS navigation, and seamless integration with your factory
                systems.
              </p>

              <div className="flex items-center gap-4 mb-8">
                <div className="flex items-center gap-2">
                  <i className="ri-shield-check-line text-2xl text-green-500" />
                  <span className="text-zinc-300">2 Year Warranty</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-tools-line text-2xl text-amber-500" />
                  <span className="text-zinc-300">Expert Installation</span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <a
                  href="#contact"
                  className="px-8 py-4 bg-amber-500 text-black font-semibold rounded-full hover:bg-amber-400 transition-colors cursor-pointer whitespace-nowrap text-center"
                >
                  <i className="ri-calendar-line mr-2" />
                  Book Installation
                </a>
                <a
                  href="https://www.aliexpress.us/item/3256809186207394.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 border-2 border-amber-500 text-amber-500 font-semibold rounded-full hover:bg-amber-500 hover:text-black transition-colors cursor-pointer whitespace-nowrap text-center"
                >
                  <i className="ri-external-link-line mr-2" />
                  View Product Details
                </a>
              </div>

              <p className="text-sm text-zinc-500">
                <i className="ri-information-line mr-1" />
                Professional installation recommended. Contact us for a free consultation.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Specifications Section */}
      <section className="py-16 bg-zinc-900/50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-white mb-8 text-center">
            Technical Specifications
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {specifications.map((spec, index) => (
              <div
                key={index}
                className="bg-zinc-950 border border-zinc-800 rounded-xl p-6 hover:border-amber-500/30 transition-colors"
              >
                <div className="text-zinc-500 text-sm mb-2">{spec.label}</div>
                <div className="text-white font-semibold">{spec.value}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-4">Advanced Features</h2>
            <p className="text-zinc-400 max-w-2xl mx-auto">
              Everything you need for a modern, connected driving experience
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-amber-500/30 transition-all hover:-translate-y-1"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-amber-500/10 rounded-xl mb-4">
                  <i className={`${feature.icon} text-3xl text-amber-500`} />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">{feature.title}</h3>
                <p className="text-zinc-400">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 bg-zinc-900/50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-white mb-8 text-center">Product Gallery</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {galleryImages.map((image, index) => (
              <div
                key={index}
                className="relative rounded-xl overflow-hidden border border-zinc-800 hover:border-amber-500/30 transition-colors group"
              >
                <img
                  src={image}
                  alt={`Car Multimedia Player ${index + 1}`}
                  className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Installation Process */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-4">
              Professional Installation Process
            </h2>
            <p className="text-zinc-400 max-w-2xl mx-auto">
              Factory-integrated installation that preserves your vehicle's original wiring and
              functionality
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {[
              { step: '01', title: 'Remove Factory Unit', icon: 'ri-tools-line' },
              { step: '02', title: 'Connect Harness Adapter', icon: 'ri-plug-line' },
              { step: '03', title: 'Install New Screen', icon: 'ri-install-line' },
              { step: '04', title: 'Configure & Calibrate', icon: 'ri-check-double-line' },
            ].map((item, index) => (
              <div
                key={index}
                className="relative bg-zinc-900 border border-zinc-800 rounded-xl p-6 text-center"
              >
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 bg-amber-500 text-black rounded-full flex items-center justify-center font-bold text-sm">
                  {item.step}
                </div>
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-amber-500/10 rounded-full mt-4">
                  <i className={`${item.icon} text-3xl text-amber-500`} />
                </div>
                <h3 className="text-white font-semibold">{item.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-b from-zinc-950 to-zinc-900">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Upgrade Your Car's Multimedia System?
          </h2>
          <p className="text-xl text-zinc-400 mb-10">
            Contact us today for professional installation and expert advice
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <a
              href="#contact"
              className="px-10 py-5 bg-amber-500 text-black font-semibold text-lg rounded-full hover:bg-amber-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-line mr-2" />
              Schedule Installation
            </a>
            <a
              href="tel:+1234567890"
              className="px-10 py-5 border-2 border-zinc-700 text-white font-semibold text-lg rounded-full hover:border-amber-500 hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2" />
              Call for Quote
            </a>
          </div>
          <div className="mt-8">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-zinc-400 hover:text-amber-500 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line" />
              Back to Home
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CarMultimediaDetailsPage;
